import { HeaderState, MenuItem } from "./types";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "store/rootReducer";
import { API_URL } from "config";

const initialState: HeaderState = {
  menuItems: [],
};

const header = createSlice({
  name: "headerSlice",
  initialState,
  reducers: {
    setMenuItems(state, action) {
      state.menuItems = action.payload;
    },
  },
});
export const { setMenuItems } = header.actions;
export const selectMenuItems = (state: RootState) => state.header.menuItems;
export const getMenuItems = () => async (
  dispatch: any,
  getState: () => RootState
) => {
  try {
    const headerData = getState().header.menuItems;
    if (headerData.length !== 0) return;
    const res = await axios.get(`${API_URL}/menu-items`);

    var sorted = res.data.data.sort(function (a: MenuItem, b: MenuItem) {
      return a.id - b.id;
    });

    dispatch(setMenuItems(sorted));
  } catch (error: any) {
    alert(error);
  }
};
export default header.reducer;
